import { spaceOf } from './useCases';

/** Which room-specific columns a booking's CSV row fills (`exportBookingsToCSV`). */
export interface CsvRoomColumns {
    /** The room's title as the address: the room family. */
    titleAsAddress: boolean;
    /** Event type: the use cases that ask for the event. */
    eventType: boolean;
    /**
     * Number of guests: the event flow (venues). Apartments count guests too,
     * but the export never carried theirs; no property of its own until that
     * is decided (collector #2050).
     */
    numberOfGuests: boolean;
}

export const csvRoomColumnsOf = (useCase: string | null | undefined): CsvRoomColumns => {
    const space = spaceOf(useCase);
    return {
        titleAsAddress: space !== null,
        eventType: space?.eventTypes === true,
        numberOfGuests: space?.flow === 'event',
    };
};
